import { gql } from '@apollo/client';

export const clearUserSearchHistoriesMutation = gql`
  mutation clearUserSearchHistories($userId: ID!) {
    clearUserSearchHistories(userId: $userId) {
      id
    }
  }
`;
